import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SmsService } from '../../services/sms.service';
import { SharedService } from '../../services/shared-service';

@Component({
    selector: 'app-send-sms',
    templateUrl: './send-sms.component.html',
    styleUrls: ['./send-sms.component.scss'],
    standalone: false
})
export class SendSmsComponent implements OnInit {

  IsLoading = false;

  constructor(
    public smsService: SmsService,
    public snackBar: MatSnackBar,
    private sharedService: SharedService) { }

  ngOnInit(): void {
  }

  public SendSms(): any {
    this.IsLoading = true;
    const SelectedCompanyId = localStorage.getItem('Empresa');
    this.smsService.sendSMS(SelectedCompanyId)
      .subscribe(res => {
        this.IsLoading = false;
        if (res.code === 0) {
          const successCountMessage = res.result.success + ' mensaje(s) con éxito';
          const failedCountMessage = res.result.failure + ' mensaje(s) fallido';
          let message = '';

          if (res.result.success !== 0 && res.result.failure !== 0) {
            message = 'SMS enviado con éxito - ' + successCountMessage + ' y ' + failedCountMessage;
            this.sharedService.ShowSnackBar(message, 'Okay', 2000);

          } else if (res.result.success !== 0 && res.result.failure === 0) {
            message = 'Todos los sms enviados con éxito - ' + successCountMessage;
            this.sharedService.ShowSnackBar(message, 'Okay', 2000);

          } else if (res.result.success === 0 && res.result.failure !== 0) {
            message = 'Enviar sms no exitoso - ' + failedCountMessage;
            this.sharedService.ShowSnackBar(message, 'Okay', 2000);

          } else {
            this.sharedService.ShowSnackBar('La tarea no existe', 'Okay', 2000);
          }
        }
      }, err => {
        this.IsLoading = false;
        console.error(err);
      });
  }

}
